import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import moment from "moment";
import countryList from "react-select-country-list";
import placeholder from "../../assets/images/userprofile.png";
import { blobToFile, scrollToFirstError } from "../../utils/helpers";
import ImageCropper from "../../Component/ImageCropper";
import SkeletonLoader from "./skeltonLoader";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";

// Redux Toolkit imports
import {
  fetchUserProfile,
  fetchUniversityPartners,
  fetchIndustries,
  fetchProgramStudies,
  fetchUpdateProfileSettings,
  fetchAreas,
  fetchObjectives,
  fetchParticularPrograms,
  fetchLanguages,
  fetchExperience,
  updateProfileStep,
  clearStepFields,
} from "./Slice/updateProfileSliceNew";
import {
  fetchCoursesCompleted,
  fetchBoardExperienceMentor,
  fetchBoardEntityTypeExperience,
  fetchAccreditedDirector,
  fetchBoardExperienceLevel,
  fetchBoardExperience,
} from "../Authentication/Register/slice/registerSlice";
import {
  normalizeUpdateProfilePayload,
  buildUpdateProfileFormData,
  deserializeBoardRoles,
} from "./helpers/updateProfile/updateProfileDataHelpers";
import { renderUpdateProfileField, renderBoardRolesInline } from "./helpers/updateProfile/updateProfileFieldRenderers";
import PropTypes from "prop-types";

const UpdateProfileStep14 = (props) => {
  const dispatch = useDispatch();
  const history = useNavigate();

  // Redux state from the slice
  const {
    universityPartners: university_partners_list,
    industries: industry_list,
    programStudies: programStudyId,
    updateProfileStepFields: registerStepFields,
    areas,
    objectives: objective,
    particularPrograms: particularProgram,
    languages: languageOptions,
    experienceData: userExperience,
  } = useSelector((state) => state.updateProfile);

  // Board-related data from register slice
  const {
    coursesCompleted,
    boardExperienceMentor,
    boardEntityTypeExperience,
    accreditedDirector,
    boardExperienceLevel,
    boardExperience,
  } = useSelector((state) => state.register);

  // Component-specific loading state to prevent flash
  const [componentReady, setComponentReady] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Other Redux state
  const { setting } = useSelector((state) => state.setting);
  const { userInfo } = useSelector((state) => state.userInfo);
  const programmes = useSelector((state) => state.programmes);
  const updateProfileData = useSelector((state) => state.updateProfileData);

  const { title, superUserParams } = props;
  const [dob, setDob] = useState(null);
  const { register, control, reset, clearErrors, trigger, handleSubmit, setValue, watch, formState, formState: { errors } } = useForm({
    defaultValues: superUserParams,
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const [roleId, setRoleId] = useState('');
  const [checkBox, setCheckBox] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [showDateDiv, setShowDateDiv] = useState("none");
  const [experience, setExperience] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [emailVerifyString, setEmailVerifyString] = useState("");
  const [readOnly] = useState(false);
  const [industryData, setIndustryData] = useState("");

  const [{ alt, src }, setImg] = useState({
    src: placeholder,
    alt: "Upload an Image",
  });
  const [cropImg, setCropImg] = useState("");
  const [cropImgModalShow, setCropImgModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedFile, setSelectedFile] = useState("");
  const [userId] = useState(userInfo?.id);
  const options = countryList().getData();
  const [country] = useState(options);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [userData, setUserData] = useState({});
  const [defaultLanguages, setDefaultLanguages] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [redirectPath, setRedirectPath] = useState(null);
  const [mainArea, setMainArea] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [experienceData, setExperienceData] = useState([]);
  const [selectedObjective, setSelectedObjective] = useState([]);
  const [selectedResume, setSelectedResume] = useState("");
  const [resumeText, setResumeText] = useState("");
  const [text, setText] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [available, setAvailable] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [employee, setEmployee] = useState("");

  const [settingData, setSettingData] = useState([]);

  const customStyles = {
    menu: (base) => ({
      ...base,
      backgroundColor: "white",
      top: "32px",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    }),
  };

  const countWords = (text) => {
    return text?.replaceAll("\r\n", "\n")?.length;

  };

  const getUniversityPartnerList = () => dispatch(fetchUniversityPartners());
  const getIndustryList = () => dispatch(fetchIndustries());
  const getProgramStudyId = () => dispatch(fetchProgramStudies());
  const registerSetting = (roleId1) => dispatch(fetchUpdateProfileSettings({ roleId: roleId1, stepKey: "step_4" }));
  const getAreasData = () => dispatch(fetchAreas());
  const getObjectiveData = (roleID) => dispatch(fetchObjectives(roleID));
  const getParticularProgram = () => dispatch(fetchParticularPrograms());
  const getLanguageList = () => dispatch(fetchLanguages());
  const getExperienceData = (_roleId) => dispatch(fetchExperience());

  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(currentYear - 1990 + 1), (val, index) => 1990 + index);

  const checkFromDate = (date) => {
    const formattedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setFromDate(formattedDate);
    setValue("from_date", formattedDate);
  };

  const checkToDate = (date) => {
    const formattedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setToDate(formattedDate);
    setValue("to_date", formattedDate);
  };

  const showDatePicker = (e) => {
    if (e.target.checked) {
      setAvailable(2);
      setShowDateDiv("block");
    } else {
      setAvailable(1);
      setShowDateDiv("none");
    }
  };

  const handleChange = (item) => {
    getExperienceData();
    setRoleId(item);

    // Fetch board-related data based on role
    if (item === "Mentor" || item === "Mentees") {
      dispatch(fetchCoursesCompleted());
      dispatch(fetchBoardExperience(item));
      dispatch(fetchBoardExperienceLevel(item));
      dispatch(fetchBoardEntityTypeExperience(item));
      dispatch(fetchAccreditedDirector(item));
      dispatch(fetchBoardExperienceMentor("Mentee")); // Always call with "Mentee" for board_entity_type_2
    }
  };

  const handleProgrammesChange = (item) => {
    if (item) {
      clearErrors("program_study_id");
    }
  };

  const handleGender = (value) => {
    setGender(value);
  };

  const setOrganizationPlaceholder = (e) => {
    const val = typeof e === "string" ? e : e?.target?.value;
    setEmployee(val);
    setValue("employee", val, { shouldValidate: true });
    if (val?.toLowerCase() === "yes") {
      setValue("employee_end_date", "");
      clearErrors("employee_end_date");
    } else if (val?.toLowerCase() !== "no") {
      setValue("employee_start_date", "");
      setValue("employee_end_date", "");
      clearErrors(["employee_start_date", "employee_end_date"]);
    }
  };

  useEffect(() => {
    getUniversityPartnerList();
    getIndustryList();
    getAreasData();
    getProgramStudyId();
    getParticularProgram();

    // Fetch settings data
    const fetchSettingsData = async () => {
      try {
        const settingResponse = await agent.get(API.SETTING);
        setSettingData(settingResponse?.data || []);
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
    fetchSettingsData();
  }, [setting]);

  useEffect(() => {
    if (languageOptions.length === 0) {
      getLanguageList();
    }
  }, [languageOptions]);

  useEffect(() => {
    if (formState.submitCount > 0 && Object.keys(errors).length > 0) {
      scrollToFirstError();
    }
  }, [formState.submitCount, errors]);

  const onSubmit = async (data) => {
    const empVal = (data.employee || employee || "")?.toLowerCase();
    if (empVal !== "yes" && empVal !== "no") {
      clearErrors(["employee_start_date", "employee_end_date"]);
      setValue("employee_start_date", "");
      setValue("employee_end_date", "");
      data.employee_start_date = "";
      data.employee_end_date = "";
    } else if (empVal === "yes") {
      clearErrors("employee_end_date");
      setValue("employee_end_date", "");
      data.employee_end_date = "";
    }
    const isValid = await trigger();
    if (!isValid) {
      scrollToFirstError();
      return;
    }
    const normalizedPayload = normalizeUpdateProfilePayload({
      data: { ...data, step_number: "step_4" },
      roleId,
      available,
      fromDate,
      toDate,
      email_verify_string: emailVerifyString,
      selectedResume,
      selectedFile,
    });

    const formData = buildUpdateProfileFormData({
      data: normalizedPayload,
      registerStepFields,
      selectedFile,
    });

    setIsLoading(true);


    dispatch(updateProfileStep({
      params: formData,
      step: "step_4",
      userId: userId,
      redirectPath: null
    }))
      .unwrap()
      .then((response) => {
        setIsLoading(false);
        if (response.success) {
          setPopupMessage(response.message);
          setShowPopup(true);
          if (response.redirectTo) {
            setRedirectPath(response.redirectTo);
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setPopupMessage(error.message || "Update failed");
        setShowPopup(true);
      });
  };

  const handlePopupOk = () => {
    setShowPopup(false);
    if (redirectPath) {
      dispatch(clearStepFields());
      history(redirectPath);
    }
  };

  const handleExperienceLevels = (data) => {
    if (!data?.experience_levels) return;

    const ids = data.experience_levels.map(item => item.id);
    setExperienceData(data.experience_levels);
    setExperience(ids);

    // For checkbox implementation, set as array of IDs
    setValue("experience_levels", ids, { shouldDirty: true });
  };
  const handleAreas = (data) => {
    const main = data?.domains ? data.domains.split(",") : [];
    const sub = data?.subareas ? data.subareas.split(",") : [];

    setMainArea(main);
    setSelectedArea(sub);

    setValue("mainArea", main);
    setValue("subarea", sub);
    setValue("domains", main);

    clearErrors("mainArea");
    clearErrors("domains");
  };


  const handleAvailability = (data) => {
    const isAvailableWithDate = data?.user_availability === 2;

    setAvailable(data?.user_availability);
    setShowDateDiv(isAvailableWithDate ? "block" : "none");
    setValue("availability", isAvailableWithDate);

    if (isAvailableWithDate) {
      checkFromDate(data.user_availability_check?.start_time);
      checkToDate(data.user_availability_check?.end_time);
    } else {
      setValue("from_date", null);
      setValue("to_date", null);
    }
  };


  const handleLanguages = (data) => {
    if (!data?.language) return;

    const selected = data.language.split(",");

    setDefaultLanguages(
      languageOptions.filter((item) =>
        selected.includes(item.value.toString())
      )
    );

    setLanguages(selected);
    setValue("language", selected);
  };


  const handleBasicProfile = (data) => {
    setRoleId(data?.role_id);
    getObjectiveData(data?.role_id);
    registerSetting(data?.role_id);

    setEmailVerifyString(data?.email_verify_string);
    setText(data?.about);
    setDob(data?.dob);

    setResumeText(
      data?.resume ? data.resume.split("resume/")[1] : ""
    );
    setSelectedResume(data?.resume);

    setImg({
      src: data?.image || placeholder,
      alt: "Upload an Image",
    });

    setSelectedFile(data?.image);

    if (data.employee) setEmployee(data.employee);
    if (data.gender) setGender(data.gender);
    if (data.country) setSelectedCountry(data.country);
  };

  const parseNumberArray = (value) =>
    value.split(",").map((id) => Number.parseInt(id.trim()));

  const parseStringArray = (value) =>
    value.split(",").map((v) => v.trim());

  const applyBoardFields = (data) => {
    const numberFields = [
      "board_entity_type",
      "board_entity_type_2",
      "course_completed",
      "accredited_director",
      "indicate_board_experience_level"
    ];

    for (const field of numberFields) {
      if (data?.[field]) {
        setValue(field, parseNumberArray(data[field]));
        clearErrors(field);
      }
    }

    if (data?.board_roles_data) {
      const boardRolesArray = deserializeBoardRoles(data.board_roles_data);
      setValue("board_roles", boardRolesArray);
      clearErrors("board_roles");
    }

    if (data?.past_board_roles) {
      setValue("past_board_roles", parseStringArray(data.past_board_roles));
      clearErrors("past_board_roles");
    }

    const singleSelectBoardFields = ["years_of_board_experience"];

    for (const field of singleSelectBoardFields) {
      if (data?.[field]) {
        setValue(field, data[field].toString());
        clearErrors(field);
      }
    }
  };

  const fetchBoardData = (data) => {
    if (data?.role_id !== "Mentor" && data?.role_id !== "Mentees") return;

    dispatch(fetchCoursesCompleted());
    dispatch(fetchBoardExperience(data?.role_id));
    dispatch(fetchBoardExperienceLevel(data?.role_id));
    dispatch(fetchBoardEntityTypeExperience(data?.role_id));
    dispatch(fetchAccreditedDirector(data?.role_id));
    dispatch(fetchBoardExperienceMentor("Mentee"));
  };

  const applyStoredImage = () => {
    const storedImg = localStorage.getItem("student_img");

    if (storedImg) {
      setSelectedFile(
        blobToFile(storedImg, `${updateProfileData?.id}.png`)
      );
    }
  };

  useEffect(() => {
    const getAreasDatas = async () => {
      try {
        const userIdToUse = updateProfileData?.id;
        if (!userIdToUse) return;

        const res = await dispatch(fetchUserProfile(userIdToUse)).unwrap();
        const data = res?.data;

        if (!data) return;

        setUserData(data);

        const { image, resume, ...rest } = data;
        reset(rest);

        setSelectedObjective(data?.objective ? data.objective.split(",") : []);

        handleBasicProfile(data);
        handleExperienceLevels(data);
        handleAreas(data);
        handleAvailability(data);
        handleLanguages(data);

        applyBoardFields(data);
        fetchBoardData(data);

        getExperienceData(data?.role_id);

        applyStoredImage();

        setTimeout(() => {
          setComponentReady(true);
          setInitialDataLoaded(true);
        }, 300);

      } catch (err) {
        console.error("Error fetching user data:", err);
      }
    };

    if (updateProfileData?.id) {
      getAreasDatas();
    }

  }, [updateProfileData?.id, setting, title]);

  useEffect(() => {
    if (experienceData?.length > 0) {
      setExperience(experienceData.map((item) => item.id));
    }
  }, [experienceData]);

  useEffect(() => {
    if (areas.length > 0 && userData?.domains) {
      const tempMain = userData.domains
        ? userData.domains.split(",").map(String)
        : [];
      const tempSub = userData.subareas
        ? userData.subareas.split(",").map(String)
        : [];

      setMainArea(tempMain);
      setSelectedArea(tempSub);

      setValue("mainArea", tempMain);
      setValue("subarea", tempSub);
      setValue("domains", tempMain);
    }
  }, [areas, userData]);

  const setSelectedMainAreaArray = (e, catId) => {
    if (document.querySelectorAll(".mainArea" + catId + ":checked").length > 0) {
      document.getElementById("mainArea" + catId).checked = true;
      document.getElementById("mainArea" + catId).classList.remove("is-invalid");
    } else {
      document.getElementById("mainArea" + catId).checked = false;
      document.getElementById("mainArea" + catId).classList.add("is-invalid");
    }
    const val = e.target.value;
    let cloneSelected = [...selectedArea];
    if (selectedArea.includes(val)) {
      cloneSelected = selectedArea.filter((item) => item !== val);
    } else {
      cloneSelected.push(val);
    }
    setSelectedArea(cloneSelected);
    /* SetMainArea keys */
    let cloneMainSelected = [...mainArea];
    if (document.querySelectorAll(".mainArea" + catId + ":checked").length == 0) {
      cloneMainSelected = cloneMainSelected.filter((item) => item != catId);
    } else {
      let newValue = catId.toString();
      if (!cloneMainSelected.includes(newValue))
        cloneMainSelected.push(newValue);
    }
    setMainArea(cloneMainSelected);
    /* SetMainArea keys */
  };

  const findAreaById = (areas, id) =>
    areas.find(area => area.id === id);

  const addSubCategories = (area, selectedArea) => {
    if (!area) return selectedArea;

    const updated = [...selectedArea];
    for (const sub of area.subcategory) {
      updated.push(sub.id.toString());
    }
    return updated;
  };

  const removeSubCategories = (area, selectedArea) => {
    if (!area) return selectedArea;

    const subcategorySet = new Set(
      area.subcategory.map(i => i.id.toString())
    );

    return selectedArea.filter(
      item => !subcategorySet.has(item)
    );
  };


  const setSelectedMainCategoryArray = (e, mainAreaId) => {
    const val = e.target.value;

    const isChecked = document.getElementById(
      "mainArea" + mainAreaId
    ).checked;

    const area = findAreaById(areas, val);

    let updatedMainArr = [...mainArea];
    let updatedSelectedArea = [...selectedArea];

    // ---- Handle main area (max 3) ----
    if (isChecked) {
      if (updatedMainArr.length >= 3) {
        document.getElementById(
          "mainArea" + mainAreaId
        ).checked = false;
        return;
      }

      updatedMainArr.push(val);
      updatedSelectedArea = addSubCategories(
        area,
        updatedSelectedArea
      );
    } else {
      updatedMainArr = updatedMainArr.filter(
        item => item !== val
      );

      updatedSelectedArea = removeSubCategories(
        area,
        updatedSelectedArea
      );
    }

    // ---- Update state ----
    setMainArea(updatedMainArr);
    setSelectedArea(updatedSelectedArea);

    // ---- Update form values ----
    setValue("domains", updatedMainArr);

    if (updatedSelectedArea.length > 0) {
      setValue("subarea", updatedSelectedArea);
      setValue("subareas", updatedSelectedArea);
    }

    // ---- Clear validation errors ----
    if (updatedMainArr.length >= 1) {
      clearErrors("domains");
      clearErrors("mainArea");
    }

    trigger("domains");
  };


  const setSelectedObjectiveArray = (e) => {
    const val = e.target.value;
    let cloneSelected1 = [...selectedObjective];

    if (selectedArea.includes(val)) {
      cloneSelected1 = selectedObjective.filter((item) => item !== val);
    } else {
      cloneSelected1.push(val);
    }

    setSelectedObjective(cloneSelected1);
  };

  const clearAll = () => {
    // Reset state arrays
    setMainArea([]);
    setSelectedArea([]);

    // Reset form values for controlled inputs
    setValue("mainArea", []);
    setValue("subarea", []);
    setValue("domains", []);

    // Optionally clear validation errors
    clearErrors("mainArea");
    clearErrors("subarea");
    clearErrors("domains");

    // Optionally re-trigger validation to update UI
    trigger("mainArea");
    setSelectedObjective([]);
    setValue("objective", []);     // reset field value in react-hook-form
    clearErrors("objective");      // clear the validation message
    trigger("objective");
  };

  const onChangePicture = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      setImg({ src: placeholder, alt: "Upload an Image" });
      setIsLoading(true);
      return;
    }

    const allowedExtensions = ["jpg", "jpeg", "png"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      setPopupMessage("Please select valid image format (jpg, jpeg, png)");
      setShowPopup(true);
      return;
    }

    // ✅ 30 MB check (STANDARDIZED)
    const sizeInMB = file.size / (1024 * 1024);
    if (sizeInMB > 30) {
      setPopupMessage("Please select image size less than 30 MB");
      setShowPopup(true);
      setImg({ src: placeholder, alt: "Upload an Image" });
      return;
    }

    clearErrors("image");

    setImg({
      src: placeholder,
      alt: file.name,
    });

    setCropImg(URL.createObjectURL(file));
    setCropImgModalShow(true);
    setIsLoading(false);
  };

  const fileToImage = (childdata) => {
    const croppedFile = blobToFile(
      childdata,
      updateProfileData?.id + ".png"
    );

    setSelectedFile(croppedFile);
    setImg({
      src: URL.createObjectURL(childdata),
      alt: "",
    });

    setValue("image", croppedFile, {
      shouldDirty: true,
      shouldValidate: true,
    });

    trigger("image");
    setCropImgModalShow(false);
  };

  const onChangeResume = (e) => {
    if (e.target.files[0]) {
      const selectedResume = e.target.files[0];
      setSelectedResume(selectedResume);
      setResumeText(selectedResume.name);
      clearErrors('resume');
    }
  };

  const renderField = (field) =>
    renderUpdateProfileField(field, {
      control,
      register,
      errors,
      watch,
      setValue,
      clearErrors,
      trigger,
      formState,
      email,
      setEmail,
      readOnly,
      roleId,
      handleChange,
      handleProgrammesChange,
      programmes,
      programStudyId,
      university_partners_list,
      years,
      userExperience,
      experience,
      setExperience,
      country,
      country1: selectedCountry,
      setCountry: setSelectedCountry,
      userData,
      languageOptions,
      customStyles,
      industry_list,
      industryData,
      setIndustryData,
      particularProgram,
      checkBox,
      setCheckBox,
      checkBox2,
      setCheckBox2,
      available,
      showDateDiv,
      checkFromDate,
      checkToDate,
      fromDate,
      toDate,
      showDatePicker,
      onChangePicture,
      selectedFile,
      src,
      alt,
      resumeText,
      onChangeResume,
      mainArea,
      setMainArea,
      selectedArea,
      setSelectedArea,
      areas,
      selectedObjective,
      setSelectedObjective,
      objective,
      dob,
      setDob,
      countWords,
      setText,
      placeholder,
      selectedResume,
      employee: employee || watch("employee") || "",
      setOrganizationPlaceholder,
      gender,
      handleGender,
      setSelectedMainAreaArray,
      setSelectedMainCategoryArray,
      setSelectedObjectiveArray,
      clearAll,
      text,
      defaultLanguages,
      setDefaultLanguages,
      languages,
      setLanguages,
      // Board-related data
      coursesCompleted,
      boardExperienceMentor,
      boardEntityTypeExperience,
      accreditedDirector,
      boardExperienceLevel,
      boardExperience,
      setting: settingData?.data || setting,
      settingData,
      setResumeText,
      setSelectedResume,
      dispatch
    });

  useEffect(() => {
    if (selectedObjective.length > 0) {
      setValue("objective", selectedObjective);
      clearErrors("objective");
      trigger("objective");
    }
  }, [selectedObjective]);

  return (
    <>
      {Object.keys(userData).length !== 0 && (
        <>
          <section>
            <Container>
              <Row className="align-items-center justify-content-center">
                <Col md={10}>
                  <div className="resetouter">

                    {(!componentReady || !initialDataLoaded || !registerStepFields || registerStepFields.length === 0) && <SkeletonLoader />}

                    <div style={{ display: (componentReady && initialDataLoaded && registerStepFields && registerStepFields.length > 0) ? 'block' : 'none' }}>

                      {registerStepFields?.length > 0 ? registerStepFields?.map((resp, index) => {
                        return (<div key={resp?.id || index} className="loginform" style={{ backgroundColor: 'white' }}>
                          <h1 className="domain-label" >{resp?.step_label}</h1>

                          <div
                            className="steps_signup"
                            style={{ marginBottom: 30 }}
                          >
                            <div>
                              <span className="stepcount active">1</span>
                              <span className="stepcount active">2</span>
                              <span className="stepcount active">3</span>
                              <span className="stepcount">4</span>
                            </div>
                          </div>

                          <Form onSubmit={handleSubmit(onSubmit, () => scrollToFirstError())}>
                            <Row>
                              {(() => {
                                // Track which board role fields have been rendered
                                let renderedBoardRoleFields = new Set();

                                return (
                                  <>
                                    {resp?.reg_feilds?.map((field, fieldIndex) => {
                                      const boardRoleFieldKeys = ['rep_company_name', 'rep_board_title', 'rep_start_date', 'rep_end_date', 'rep_label'];
                                      const isBoardRoleField = boardRoleFieldKeys.includes(field.reg_key);

                                      // Skip if already rendered as part of a group
                                      if (renderedBoardRoleFields.has(field.reg_key)) {
                                        return null;
                                      }

                                      // If this is the first board role field, render the entire group
                                      if (isBoardRoleField && field.reg_key === 'rep_company_name') {
                                        renderedBoardRoleFields.add('rep_company_name');
                                        renderedBoardRoleFields.add('rep_board_title');
                                        renderedBoardRoleFields.add('rep_start_date');
                                        renderedBoardRoleFields.add('rep_end_date');

                                        return (
                                          <React.Fragment key="board_roles_group">
                                            {renderBoardRolesInline(resp?.reg_feilds, {
                                              control,
                                              register,
                                              errors,
                                              watch,
                                              setValue,
                                              clearErrors,
                                              trigger,
                                              roleId,
                                              setting: settingData?.data || setting,
                                              formState,
                                            })}
                                          </React.Fragment>
                                        );
                                      }

                                      // Skip other board role fields (they're rendered as a group)
                                      if (isBoardRoleField) {
                                        return null;
                                      }

                                      // Render normal fields
                                      return (
                                        <React.Fragment key={field.reg_key || fieldIndex}>
                                          {renderField(field)}
                                        </React.Fragment>
                                      );
                                    })}

                                    <Col md={12}>
                                      <div className="form-group mt-3 text-center">

                                        <Button
                                          className="btn btn_red loginsubmit nextbtn outline me-2"
                                          onClick={() => {
                                            clearAll();
                                          }}
                                        >
                                          Clear All
                                        </Button>
                                        <Button
                                          className="btn btn_red loginsubmit nextbtn outline ms-2"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            history("/manage-profile-step2");
                                          }}
                                        >
                                          Previous
                                        </Button>

                                        <button
                                          type="submit"
                                          className="btn btn_red loginsubmit nextbtn ms-2"
                                          disabled={isLoading}
                                        >
                                          {isLoading ? "Submitting..." : "Save & Next"}
                                        </button>

                                      </div>
                                    </Col>
                                  </>
                                );
                              })()}
                            </Row>
                          </Form>
                        </div>
                        )
                      }) : (
                        <div>Loading step configuration...</div>
                      )}

                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {cropImgModalShow && (
            <ImageCropper
              show={cropImgModalShow}
              cropImg={cropImg}
              fileToImage={fileToImage}
              onHide={() => { setCropImgModalShow(false) }}
              centered
              size="xl"
              className="cropper-modal"
            />
          )}

          <PopupModalWithOk
            show={showPopup}
            onHide={handlePopupOk}
            message={popupMessage}
            showConfirm={false}
            staticBackdrop={true}
          />
        </>
      )}
    </>
  );
};
UpdateProfileStep14.propTypes = {
  title: PropTypes.string,
  superUserParams: PropTypes.object,
};

export default UpdateProfileStep14;